import { render } from "./TecnologiaView.vue?vue&type=template&id=464dc143&scoped=true"
import script from "./TecnologiaView.vue?vue&type=script&lang=js"
export * from "./TecnologiaView.vue?vue&type=script&lang=js"

import "./TecnologiaView.vue?vue&type=style&index=0&id=464dc143&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-464dc143"]])

export default __exports__